export class Group {
  name: string;

  constructor(data) {
    this.name = data.name;
  }
}
